module.exports = __webpack_public_path__ + "static/img/Stats_nulldata.7615563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stats/Stats_nulldata.png?v1232
// module id = 522
// module chunks = 3 4 5 6